import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { LetDirective } from '@ngrx/component';
import { FormlyModule } from '@ngx-formly/core';
import { NgxMaskDirective } from 'ngx-mask';

import { MaterialModule } from '@lockton-apps/material';
import { UiModule } from '@lockton-apps/shared/ui/lui';
import {
  ToggleListComponent,
  ToggleListItemComponent,
  ToggleListItemTitleDirective,
} from '@lockton-apps/shared/ui/toggle-list';
import {
  CastArrayPipe,
  GetPipe,
  IsNilPipe,
} from '@lockton-apps/shared/util/ng-lodash';

import { DynamicFormCalcTableModule } from '../dynamic-form-calc-table/dynamic-form-calc-table.module';
import { DynamicFormCardModule } from '../dynamic-form-card/dynamic-form-card.module';
import { DynamicFormTableModule } from '../dynamic-form-table/dynamic-form-table.module';
import { FieldMetaPipe } from '../pipes/field-meta/field-meta.pipe';
import { DynamicFieldTypeComponent } from './dynamic-field-type.component';
import { DynamicFormCellModule } from '../dynamic-form-cell/dynamic-form-cell.module';

@NgModule({
  declarations: [DynamicFieldTypeComponent],
  providers: [FieldMetaPipe],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMaskDirective,

    FormlyModule.forChild({
      types: [
        {
          name: 'dynamic',
          component: DynamicFieldTypeComponent,
          defaultOptions: {
            props: {
              saveText: $localize`Save`,
              addAnotherText: $localize`Add another`,
              cancelText: $localize`Cancel`,
              saveChangesText: $localize`Save changes`,
            },
          },
        },
      ],
    }),
    UiModule,
    MatIconModule,
    CastArrayPipe,
    MaterialModule,
    LetDirective,
    DynamicFormCardModule,
    DynamicFormTableModule,
    ToggleListComponent,
    ToggleListItemComponent,
    ToggleListItemTitleDirective,
    IsNilPipe,
    DynamicFormCalcTableModule,
    DynamicFormCellModule,
    FieldMetaPipe,
    GetPipe,
  ],
})
export class DynamicFieldTypeModule {}
